export default __webpack_public_path__ + "static/media/ic-notification-empty.e82551ca.svg";